import { z } from 'zod';
import { ExtrapolationTypeSchema } from './FunnelSource';

export type FunnelStageGroupConfig = z.infer<typeof FunnelStageGroupConfigDTO>;

export const FunnelStageGroupConfigDTO = z.object({
  id: z.number().optional(),
  name: z.string(),
  desc: z.string(),
  sources: z.array(z.string()),
  extrapolation_type: ExtrapolationTypeSchema,
});

export const exampleFunnelStageGroupConfig: FunnelStageGroupConfig = {
  name: 'Funnel Stage Group',
  desc: 'Description',
  sources: ['fbleads'],
  extrapolation_type: 'Disabled',
};
